export default __webpack_public_path__ + "static/media/pouty-mo-court-liz.776d57f5.png";